module.exports = __webpack_public_path__ + "img/base10_positioning.766ed476.png";